import { createElement, memo, type ReactNode } from 'react';
import type { SvgNode } from '../lib/mascotSvg';

/**
 * Un árbol de `lib/mascotSvg.ts` dibujado con React: el cuerpo de una mascota, o una
 * pieza de su cara calcada. `colors` repinta por color (hex original → nuevo); el nuevo
 * puede ser una variable CSS (`var(--ropa-a)`), que va por `style` y no como atributo.
 */
// Cientos de paths: que no se redibujen cuando solo cambia la expresión.
export const MascotBody = memo(function Body({ root, colors }: { root: SvgNode[]; colors: Record<string, string> }) {
  const draw = (n: SvgNode, i: number): ReactNode => {
    const props: Record<string, unknown> = { key: i };
    const style: Record<string, string> = {};
    for (const [k, v] of Object.entries(n.attrs)) {
      const name = k.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
      const paint = (k === 'fill' || k === 'stroke') ? (colors[v] ?? v) : v;
      if (paint.startsWith('var(')) style[name] = paint;
      else props[name] = paint;
    }
    if (Object.keys(style).length > 0) props.style = style;
    return createElement(n.tag, props, ...n.children.map(draw));
  };
  return <>{root.map(draw)}</>;
});
